var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ModalFormFormat, } from "../../UI/FormFormat/FormFormat";
import FolderForm from "./FolderForm";
import FolderService from "../../../Services/Folder.service";
const CreateFolderModal = (_a) => {
    var { personType } = _a, modalProps = __rest(_a, ["personType"]);
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { modalTitle: "New Folder", defaultValue: {
            name: "",
        }, handleSubmit: (state) => FolderService.create({
            name: state.name,
            personType,
        }), children: _jsx(FolderForm, {}) })));
};
export default CreateFolderModal;
